import { handleActions } from "redux-actions";
import { FETCH, FETCH_FAILURE, FETCH_SUCCESS } from "./actions";

const initialState = {
  loading: false,
  loaded: false,
  levels: null
};

export default handleActions(
  {
    [FETCH]: state => ({
      ...state,
      loading: true
    }),
    [FETCH_SUCCESS]: (state, { payload }) => ({
      ...state,
      ...payload,
      loading: false,
      loaded: true
    }),
    [FETCH_FAILURE]: (state, { payload }) => ({
      ...state,
      ...payload,
      loading: false,
      loaded: false
    })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/reducers/levels/reducer.js